import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import SAVE_TOOL_PREFERENCES from './SaveToolPreferences.gql';

const parseResult = (result) => {
  const initialState = {};

  const saveToolPreferencesResponse = get(result, 'core.updateToolPreferences');
  return {
    ...initialState,
    ...saveToolPreferencesResponse,
  };
};

export const useSaveToolPreferencesQuery = (options) => {
  const [queryResult, queryAction] = useQuery(SAVE_TOOL_PREFERENCES, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
